import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupHeaderActions" */ './lazyIndex'),
    { name: 'GroupHeaderActions' }
);

export const lazySetGroupHeaderCallbacks: LazyAction<
    typeof lazyIndex.setGroupHeaderCallbacks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setGroupHeaderCallbacks);
